/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object, shape, string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';

const styles = () => ({
    heading: {
        display: 'flex',
        justifyContent: 'left',
        padding: '30px',
        margin: '30px auto 0',
        maxWidth: '1400px',
        '& > div': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '35%',
        },
        '& h3': {
            display: 'block',
            margin: '0 auto 10px',
            fontSize: '1.6em',
            textAlign: 'center',
        },
        '& img': {
            width: '100%',
            maxWidth: '300px',
        },
    },
    headingMob: {
        padding: '0 10px 0 3px',
        marginTop: '15px',
        '& h3': {
            display: 'inline',
            fontSize: '4.1vw',
            padding: '5px',
            width: '60%',
            margin: '0',
            textAlign: 'left',
            lineHeight: '1.2em',
        },
    },
});

const Heading = ({
    data, classes,
}) => {
    if (!data) return null;

    const getStyles = (device) => {
        const style = {};

        switch (device) {
            case 'desktop':
                style.background = `url(${data.image_bg_desktop?.url}) no-repeat center center`;
                if (data.heading_font?.length) style.fontFamily = data.heading_font.split(':')[1].replace(';', '');
                break;
            case 'mobile':
                style.background =  `url(${data.image_bg_mobile?.url || data.image_bg_desktop?.url}) no-repeat center center`;
                style.backgroundSize = 'cover';
                if (data.heading_font?.length) style.fontFamily = data.heading_font.split(':')[1].replace(';', ''); // desktop fallback
                if (data.heading_font_mobile?.length) style.fontFamily = data.heading_font_mobile.split(':')[1].replace(';', ''); // mobile - if defined
                break;
            default:
                return null;
        }
        style.backgroundSize = 'cover';

        if (data.heading_font?.length) style.fontFamily = data.heading_font?.split(':')[1].replace(';', '');
        return style;
    };

    return (
        <DesktopMobile
            desktop={() => (
                <div className={classes.heading} style={getStyles('desktop')}>
                    <div>
                        <h3>{data.heading_copy}</h3>
                        <img src={data.brand_logo?.url} alt={data.brand_logo?.title} />
                    </div>
                </div>
            )}
            mobile={() => (
                <div className={`${classes.heading} ${classes.headingMob}`} style={getStyles('mobile')}>
                    <h3>{data.heading_copy_mobile}</h3>
                </div>
            )}
            breakpoint={767}
        />
    );
};

Heading.propTypes = {
    data: shape({
        image_bg_desktop: object,
        image_bg_mobile: object,
        brand_logo: object,
        heading_copy: string,
        heading_copy_mobile: string,
    }),
    classes: object.isRequired,
};
Heading.defaultProps = {
    data: {
        image_bg_desktop: {},
        image_bg_mobile: {},
        brand_logo: {},
        heading_copy: '',
        heading_copy_mobile: '',
    },
};
export default withStyles(styles)(Heading);
